<script setup lang="ts">
import { storeToRefs } from 'pinia'
import BaseModal from './wrappers/BaseModal.vue'
import { useModelWrapper } from './wrappers/helpers/useModelWrapper'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '../store/useUserStore'
import { computed } from 'vue'
const props = defineProps<{
  modelValue: boolean
  stopTravel: boolean
}>()
const emit = defineEmits<{
  (e: 'confirmTravel', confirmation: boolean): void
  (e: 'update:modelValue'): void
}>()
const show = useModelWrapper(props, emit)
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)

const confirm = () => {
  emit('confirmTravel', true)
  show.value = false
}
const user = storeToRefs(useUserStore())
const message = computed(() => {
  switch (user.language.value) {
    case 'fr_CA': //french is always km
      if (props.stopTravel)
        return 'Les activités de voyage supérieures à 640 ne sont pas autorisées. Veuillez contacter la direction pour toute question.'

      return 'Vous avez saisi plus de 160 km pour ce déplacement, souhaitez-vous poursuivre?'
    default:
      if (props.stopTravel)
        return `Travel Activity over ${
          user.distance.value == 'miles' ? 400 : 640
        } is not permitted- Please Contact Management for any questions`

      return `You have entered more than ${user.distance.value == 'miles' ? 100 : 160} ${
        user.distance.value
      } for this travel, do you want to proceed?`
  }
})
</script>
<template>
  <BaseModal v-model="show">
    <template #title>{{ t('activities.travel') }}</template>
    <template #content>
      {{ message }}
    </template>
    <template #actions>
      <div align="right">
        <q-btn flat no-caps class="text-grey-7" :label="label('cancel')" v-close-popup />
        <q-btn v-if="!stopTravel" @click="confirm()" color="primary" :label="label('continue')" />
      </div>
    </template>
  </BaseModal>
</template>
